import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeExclusion } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useRemoveExclusion = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ courseConfigId, employeeId }) =>
      removeExclusion(courseConfigId, employeeId),
    onSuccess: (_, variables) => {
      queryClient.refetchQueries({
        queryKey: moodleQueryKeys.courseExclusions(variables.courseConfigId),
      });
    },
  });

  return { mutate, isPending };
};
